// components/shared/products/ProductsList.tsx
import { ProductCard } from "./ProductCard";
import { Product } from "@cabukaka/types";
import { toast } from "sonner";
import { useCart } from "../../../hooks/cart/useCart";

interface ProductsListProps {
  products: Product[];
  layout?: "grid" | "horizontal-scroll" | "vertical-list";
  columns?: {
    mobile?: number;
    tablet?: number;
    desktop?: number;
  };
  actionLabel?: string;
  showOriginalPrice?: boolean;
  showRating?: boolean;
  showReviewsCount?: boolean;
  showShopName?: boolean;
  showShopAddress?: boolean;
  showUnit?: boolean;
  showDescription?: boolean;
  showActionBtn?: boolean;
}

export function ProductsList({
  products,
  layout = "grid",
  columns = { mobile: 1, tablet: 2, desktop: 4 },
  actionLabel,
  showOriginalPrice = true,
  showRating = true,
  showReviewsCount = true,
  showShopName = true,
  showShopAddress = true,
  showUnit = true,
  showDescription = true,
  showActionBtn = true
}: ProductsListProps) {

  const { addToCart } = useCart();
   console.log(products)
  const handleAddToCart = (product: Product) => {
    addToCart(product.id);
    toast.success(`${product.name} ajouté au panier`);
  };

  if (layout === "horizontal-scroll") {
    return (
      <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide">
        {products.map((product, index) => (
          <ProductCard
            key={product.id + index}
            product={product}
            layout="horizontal-scroll"
            onAddToCart={handleAddToCart}
            actionLabel={actionLabel}
            showOriginalPrice={showOriginalPrice}
            showRating={showRating}
            showReviewsCount={showReviewsCount}
            showShopName={showShopName}
            showShopAddress={showShopAddress}
            showUnit={showUnit}
            showDescription={showDescription}
            showActionBtn={showActionBtn}
          />
        ))}
      </div>
    );
  }

  if (layout === "vertical-list") {
    return (
      <div className="flex flex-col gap-4">
        {products.map((product, index) => (
          <ProductCard
            key={product.id + index}
            product={product}
            layout="grid"
            onAddToCart={handleAddToCart}
            actionLabel={actionLabel}
            showOriginalPrice={showOriginalPrice}
            showRating={showRating}
            showReviewsCount={showReviewsCount}
            showShopName={showShopName}
            showShopAddress={showShopAddress}
            showUnit={showUnit}
            showDescription={showDescription}
            showActionBtn={showActionBtn}
          />
        ))}
      </div>
    );
  }

  // Grid layout - version simple avec des classes conditionnelles
  const getGridClasses = () => {
    const mobile = columns.mobile === 1 ? 'grid-cols-1' : 'grid-cols-2';
    const tablet = columns.tablet === 2 ? 'sm:grid-cols-2' : columns.tablet === 3 ? 'sm:grid-cols-3' : 'sm:grid-cols-4';
    const desktop = columns.desktop === 3 ? 'lg:grid-cols-3' : columns.desktop === 4 ? 'lg:grid-cols-4' : columns.desktop === 5 ? 'lg:grid-cols-5' : 'lg:grid-cols-4';
    
    return `grid ${mobile} ${tablet} ${desktop} gap-4 md:gap-6`;
  };

  return (
    <div className={getGridClasses()}>
      {products.map((product, index) => (
        <ProductCard
          key={product.id + index}
          product={product}
          layout="grid"
          onAddToCart={handleAddToCart}
          actionLabel={actionLabel}
          showOriginalPrice={showOriginalPrice}
          showRating={showRating}
          showReviewsCount={showReviewsCount}
          showShopName={showShopName}
          showShopAddress={showShopAddress}
          showUnit={showUnit}
          showDescription={showDescription}
          showActionBtn={showActionBtn}
        />
      ))}
    </div>
  );
}